import $ from 'jquery'
import { alert_error, alert_message, post_json, get_json, eval_html_template,
         get_myinfo, has_user_loggedin, alert_message_html } from '../../common'

$(init)

async function init () {
  let $page = $('#user-referral-page')
  if ($page.length == 0) {
    return
  }
  try {
    let myinfo = await get_myinfo()
    let loggedin = has_user_loggedin(myinfo)
    if (!loggedin) {
      return
    }
    let refdata = (await get_json(`/users/get-referral-data`)).data

    $page.removeClass('page-not-ready').addClass('page-ready')
    
    $('#my-referral-code').text(refdata.referral_code)
    $('#my-referral-link').attr('href', refdata.referral_link)
      .text(refdata.referral_link)
    let $setsection = $('#set-referral-code-section')
    let setreg_disabled = !refdata.registered_referral_code
    $setsection.find('input').val(refdata.registered_referral_code || '')
      .prop('disabled', !setreg_disabled)
    $setsection.find('.when-enabled').toggleClass('d-none', !setreg_disabled)
    $setsection.find('.when-disabled').toggleClass('d-none', setreg_disabled)
    $setsection.on('submit', async ($evt) => {
      $evt.preventDefault()
      let referral_code = $setsection.find('input').val()
      if (!referral_code) {
        alert_error('Please insert referral code')
        return
      }
      try {
        await post_json('users/register-referral-code', { referral_code })
        location.reload()
      } catch (err) {
        alert_error(err)
      }
    })
    $setsection.find('button').prop('disabled', !setreg_disabled)
  } catch (err) {
    alert_error(err)
  }
}
